<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <b-table
            id="raffle-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{ afterResize: columnsWidthChanged }"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(surname)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(phone)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(serial)="data">{{ $t(data.label) }}</template>

            <template v-slot:head(created)="data">{{
              $t(data.label)
            }}</template>

            <template v-slot:cell(created)="data">
              <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space: nowrap" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit('bv::refresh::table', 'raffle-table')
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import BulkActionSelect from "@/components/BulkActionSelect";
import TableFilters from "@/components/TableFilters";
import moment from "moment";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    BulkActionSelect,
    TableFilters,
  },
  name: "raffle",
  mixins: [tableMixin],
  data: function () {
    return {
      tableName: "raffle",

      bulkAction: null,
      bulkActionOptions: [],

      filterOptions: [
        {
          field: "raffle_id",
          multiple: false,
          placeholder: "Raffle ID",
          options: [
            { name: "World Cup 2022 Qatar", value: "worldcup2022qatar" },
            { name: "Liga Winner", value: "liga_winner" },
          ],
          selected: [
            { name: "World Cup 2022 Qatar", value: "worldcup2022qatar" },
          ],
        },
        {
          field: "created",
          type: "date",
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
          ranges: {
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment().subtract(1, "days").startOf("day"),
              moment().subtract(1, "days").endOf("day"),
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek"),
            ],
            "Last week": [
              moment().subtract(1, "week").startOf("isoWeek"),
              moment().subtract(1, "week").endOf("isoWeek"),
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()],
          },
        },
      ],

      isBusy: false,
      sortBy: "created",
      sortDesc: true,
      fields: [
        {
          key: "eid",
          label: "Id",
          sortable: true,
          ignore: true,
          class: "d-none",
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
          class: "",
        },
        {
          key: "surname",
          label: "Surname",
          sortable: true,
          class: "",
        },
        {
          key: "phone",
          label: "Phone",
          sortable: true,
          class: "",
        },
        {
          key: "serial",
          label: "Ticket Serial",
          sortable: true,
          class: "",
        },
        {
          key: "created",
          label: "Created at",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "raffle_id",
          label: "Raffle ID",
          sortable: true,
          ignore: true,
          class: "",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "",
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["raffle/endpoint"];

      console.log(
        "exportLink",
        `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`
      );

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach((item) => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      console.log("paginationData", paginationData);

      return JSON.stringify(paginationData);
    },
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "raffle-table");
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.type != "date" && item.selected && item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = this.specialDate(
              item.selected.startDate,
              true
            );
            paginationData.dateEnd = this.specialDate(
              item.selected.endDate,
              false
            );
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = this.specialDate(
              moment().startOf("day"),
              true
            );
            paginationData.dateEnd = this.specialDate(
              moment().endOf("day"),
              false
            );
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }
      return paginationData;
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = this.buildPagination();

      this.$store
        .dispatch("raffle/fetch", paginationData)
        .then((resp) => {
          this.totalRows = resp.data.total;
          callback(resp.data.rows);
        })
        .catch((err) => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

